import type { CSSProperties, ReactNode } from 'react';
import Badge from '@/components/pages/badge';
import { Watch } from '@/components/pages/icons';
import type { NavbarWrapper } from './type';
import clsx from 'clsx';

export function NavbarWrapper({
  isMenuOpen,
  top,
  transitionToTop,
  hideBadge,
  initialState,
  initialTop,
  children,
  className,
}: NavbarWrapper & { initialState: boolean; children: ReactNode }) {
  const cssVars = {
    '--navbar-top-mobile': `${initialTop?.mobile ?? 0}px`,
    '--navbar-top-desktop': `${initialTop?.desktop ?? 0}px`,
    transition: transitionToTop,
    ...(top != null ? { top: `${top}px` } : {}),
  } as CSSProperties;
  /* REQUIRED data-menu attribute for click outside and keep server side */
  return (
    <div
      {...{ open: isMenuOpen, 'data-initial-state': initialState.toString() }}
      className={clsx(
        'group fixed left-0 @lg:right-0 @lg:mx-auto flex justify-center max-w-page w-full @lg:px-16 z-100',
        'top-(--navbar-top-mobile) @lg:top-(--navbar-top-desktop)',
        className
      )}
      style={cssVars}
      data-menu
    >
      <div
        className={`relative w-full max-h-svh ${!hideBadge ? '@lg:pt-3 group-open:@lg:pt-3' : ''}`}
      >
        {!hideBadge && (
          <Badge
            label="Available 24/7, replies in <5 min"
            className="hidden @lg:flex absolute right-[99px] top-0 z-10"
            icon={<Watch className="h-3 w-3 shrink-0" />}
          />
        )}
        <div
          className="
            max-h-full group-hover:bg-white group-open:bg-white group-open:rounded-2xl @lg:rounded-[50px] group-open:@lg:rounded-[50px] overflow-hidden transition-all duration-300 ease-in-out isolate bg-clip-padding @lg:border @lg:border-transparent transform-gpu [-webkit-mask-image:-webkit-radial-gradient(white,black)] @lg:group-data-[initial-state=true]:border-white/15 @lg:group-data-[initial-state=true]:backdrop-blur-xl group-data-[initial-state=false]:backdrop-blur-2xl @lg:group-data-[initial-state=false]:bg-white
          "
          data-cover
        >
          {children}
        </div>
      </div>
    </div>
  );
}
